/* eslint-disable no-undef */
import { resultsDuckCreator } from 'axl-ducks';
import { createSelector, DuckSelector } from '@atc/modular-redux';

export default resultsDuckCreator({
    namespace: 'RECENT',
    storePrefix: 'recent',
    store: 'domain',
}).extend({
    selectors: {
        getResults: (state) => state.recentdomain.activeResults,
        getActiveInventoryResults: new DuckSelector((selectors) => createSelector(
            selectors.getResults,
            (activeResults) => activeResults.filter((result) => inventory[result] !== undefined)
                .map((item) => {
                    const inventoryItem = inventory[item];
                    return {
                        ...inventoryItem,
                        ...(inventoryItem ? { isSaved: savedListingIds.includes(inventoryItem.id) } : {}),
                    };
                })
        )),
    },
});
